
import React from "react";
import { Col, Container, Row, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ssoLogOut } from "../../Services/auth";
import Logo from "../../Asset/Img/logo.svg";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux"
import "./index.css"
import "./index.css";
import { setAuth } from "../../Redux/Slice/authSlice"


const Header = () => {
    const dispatch = useDispatch();
    let navigate = useNavigate();

    let handleLogout = async () => {
        localStorage.clear()
        dispatch(setAuth({ isAuthenticated: false, token: '', loginType: '' }))
        window.location.href = "/login";
        return
        let res = await ssoLogOut(localStorage?.access_token)
        if (res && res.status == '200') {
            localStorage.clear()
            dispatch(setAuth({ isAuthenticated: false, token: '', loginType: '' }))
            navigate('/login')
        }
    }

    let getInitials = () => {
        const firstName = localStorage?.firstName?.charAt(0) || "";
        const surname = localStorage?.lastName?.charAt(0) || "";
        if (firstName.length > 0 && surname.length > 0) {
            return firstName[0] + surname[0];
        } else if (firstName.length > 0 && surname.length <= 0) {
            return firstName[0];
        } else {
            return "";
        }
    }
    return (
        <header className="header-layout">
            <Container fluid>
                <Row className="align-items-center">
                    <Col xs={6} md={3}>
                        <div className="logo">
                            <span className="logo-brand"><img src={Logo} alt="logo" /></span>
                        </div>
                    </Col>
                    <Col xs={6} md={9}>
                        <div className="text-end">
                            <ul className="hmt-menu mb-0">
                                <li onClick={() => navigate('/pricebook')} className={`menu-itms-nv ${window.location.pathname == ('/pricebook') ? 'active' : ''}`}><Link to="/">PriceBook</Link></li>
                                <li onClick={() => navigate('/dashboard')} className={`menu-itms-nv ms-3 ${window.location.pathname.includes('dashboard') ||  window.location.pathname == '/pricebook-list' ? 'active' : ''}`}><Link to="dashboard">Dashboard</Link></li>
                                <li className="menu-itms-nv ms-3">
                                    <Dropdown>
                                        <Dropdown.Toggle variant="" className="btn-nm-profile" id="profile-user-id"><span className="user-txt-circle">{getInitials()}</span></Dropdown.Toggle>
                                        <Dropdown.Menu className="dropdow-menu-profile" align="end">
                                            <div className="middle-usr-flx">
                                                <div className="top-us-pts d-flex justify-content-between">
                                                    <div className="left-sd--wtm"><span className="txt-small-su">S3S</span></div>
                                                    <div onClick={handleLogout} style={{ cursor: 'pointer' }} className="right-sd--wtm"><span className="txt-small-su">Sign Out</span></div>
                                                </div>
                                                <div className="d-flex flex-wrap mng-user-flx align-items-center">
                                                    <div className="user-icon-web">
                                                        <span className="user-nm-short">{getInitials()}</span>
                                                    </div>
                                                    <div className="user-info-pfl">
                                                        <div className="inf-flxcard-wt">
                                                            <h4 className="fl-name-txt">{localStorage?.userName}</h4>
                                                            <span className="type-user-txt">{localStorage.email}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </li>
                            </ul>
                        </div>
                    </Col>
                </Row>
            </Container>
        </header>

    )
}
export default Header;